import { render, staticRenderFns } from "./VideoStreaming.vue?vue&type=template&id=a6dce874&scoped=true"
import script from "./VideoStreaming.vue?vue&type=script&lang=js"
export * from "./VideoStreaming.vue?vue&type=script&lang=js"
import style0 from "./VideoStreaming.vue?vue&type=style&index=0&id=a6dce874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6dce874",
  null
  
)

export default component.exports